<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper"
     style="color: #8d97ad">
  <!--[style.margin-top.px]="((layoutManager.mobileMode)?0:0) + ((!layoutManager.mobileMode && layoutManager.innerWidth<1389)?100:0)"-->

  <!-- ============================================================== -->
  <!-- Static Slider 10  -->
  <!-- ============================================================== -->
  <div class="banner-innerpage" style="background-image:url('../../assets/images/banner-bg3.jpg')">
    <div class="container">
      <!-- Row  -->

      <div class="row justify-content-center ">
        <!-- Column -->
        <div class="col-md-6 align-self-center text-center" data-aos="fade-down" data-aos-duration="1200">
          <h1 class="title">Affiliate Program</h1>
          <h6 class="subtitle op-8">Il nostro programma di affiliazione ti permettere di diventare nostro partner e di crescere insieme a noi!</h6> </div>
        <!-- Column -->
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Static Slider 10  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Feature 26 -->
    <!-- ============================================================== -->
    <div class="spacer feature26">
      <div class="container">
        <div class="row wrap-feature-26">
          <div class="col-md-6 align-self-center">
            <div class="max-box">
              <h2 class="title m-t-20">Perché diventare nostro affiliato? </h2>
              <p class="m-t-30">Il programma di affiliazione ti permette di ricevere mensilmente commissioni fino al <b>30%</b> su ogni ordine effettuato dagli utenti registrati sotto affiliazione.</p>
              <p>Questo sistema ti permette di creare la tua rete di clienti, i cui poi possono seguire i tuoi consigli e le tue raccomandazioni. Ad ogni licenza rinnovata e ad ogni prodotto
                acquistato dal cliente riceverai la percentuale, visibile nella tua area personale.</p>
              <a href="javascript:void(0)" class="linking" (click)="scroll(contactdiv)">Richedi applicazione <i class="ti-arrow-right"></i></a>
            </div>
          </div>
          <div class="col-md-5 col-md-5 ml-auto"> <img src="../../../assets/images/world3.JPEG" alt="assetstore" class="img-responsive img-rounded" /> </div>
        </div>
        <div class="row wrap-feature-26 m-t-40 p-t-30">
          <div class="col-md-5"> <img src="../../../assets/images/market.jpg" alt="assetstore" class="img-responsive img-rounded" /> </div>
          <div class="col-md-6 ml-auto align-self-center">
            <h2 class="title m-t-20">Non limitarti alla tua rete di clienti, crea una rete di sub-affiliati</h2>
            <p class="m-t-30">Come la rete di clienti, puoi creare una rete di sub-affiliati, senza limiti sulle commissioni che dai loro clienti otterrai.</p>
            <p>Il programma di sub-affiliazione ti permette di ricevere una percentuale su ogni licenza rinnovata e prodotto acquistato da ogni cliente dei sub-affiliati.</p>
            <a class="linking" data-toggle="collapse" href="#f26" (click)="scroll(contactdiv)">Richiedi applicazione  <i class="ti-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <p #contactdiv></p>
    <br><br><br>
    <!-- ============================================================== -->
    <!-- End Feature 26 -->
    <!-- ============================================================== -->



    <!-- ============================================================== -->
    <!-- Contact 3  -->
    <!-- ============================================================== -->
    <div class="contact3 mini-spacer">
      <div class="row">
        <div class="container">
          <div class="row m-0">
            <div class="col-lg-6">
              <div class="card-shadow" data-aos="flip-left" data-aos-duration="1200">
                <img src="../../../assets/images/partner2.png" class="img-responsive img-rounded" style="margin-top: 0">
              </div>
            </div>

            <div class="contact-box m-l-30 ">

              <h1 class="title font-light m-t-10">Registra un account Partner</h1>

              <!--
              <form class="m-b-40">
                <div class="form-group">
                  <h6 class="m-b-20 font-medium">CUSTOMER INFORMATION</h6>
                  <input type="text" class="form-control" value="Email Address">
                </div>
              </form>
              <form class="m-t-40">
                <div class="row">
                  <div class="form-group col-md-6">
                    <input type="text" class="form-control" value="First Name">
                  </div>
                  <div class="form-group col-md-6">
                    <input type="text" class="form-control" value="Last Name">
                  </div>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" value="Postal Address">
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <select class="form-control custom-select">
                      <option>Country</option>
                      <option>Country name</option>
                      <option>Country name</option>
                      <option>Country name</option>
                      <option>Country name</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <select class="form-control custom-select">
                      <option>State</option>
                      <option>State name</option>
                      <option>State name</option>
                      <option>State name</option>
                      <option>State name</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <select class="form-control custom-select">
                      <option>City</option>
                      <option>City name</option>
                      <option>City name</option>
                      <option>City name</option>
                      <option>City name</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <input type="text" class="form-control" value="Zip Code">
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-auto my-1">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customControlAutosizing">
                      <label class="custom-control-label" for="customControlAutosizing">I agree with <a href="">Terms &amp; Condition</a></label>
                    </div>
                  </div>
                </div>
                <button type="submit" class="btn btn-info-gradiant m-t-20 btn-arrow"><span> SUBMIT <i class="ti-arrow-right"></i></span></button>
              </form>
              -->

              <form [formGroup]="formGroup" class="m-b-40">
                <div class="row">
                  <div class="form-group col-md-6">
                    <mat-form-field style="width: 90%;margin-left: 5px">
                      <input matInput placeholder="Nome" formControlName="name"
                             [errorStateMatcher]="matcher" value="" required>
                    </mat-form-field>
                  </div>
                  <div class="form-group col-md-6">
                    <mat-form-field style="width: 90%;margin-left: 5px">
                      <input matInput placeholder="Cognome" formControlName="surname"
                             [errorStateMatcher]="matcher" value="" required>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" style="margin-top: -20px">
                  <div class="form-group col-md-12">
                    <mat-form-field style="width: 95%;margin-left: 5px">
                      <input matInput placeholder="{{'login.email-placeholder'|translate}}" formControlName="email"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('email').hasError('email') && !formGroup.get('email').hasError('required')">
                        {{'login.email-not-valid'|translate}}
                      </mat-error>
                      <mat-error *ngIf="formGroup.get('email').hasError('required')">
                        {{'login.null-value-error'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" style="margin-top: -20px">
                  <div class="form-group col-md-6">
                    <mat-form-field  style="width: 90%;margin-left: 5px">
                      <input type="password" matInput placeholder="{{'login.password-placeholder'|translate}}" formControlName="password" value = ""
                             [errorStateMatcher]="matcher" required>
                      <mat-error *ngIf="formGroup.get('password').hasError('minlength') && !formGroup.get('password').hasError('required')" >
                        {{'sign-in.password-rule-1'|translate}}
                      </mat-error>
                      <mat-error *ngIf="formGroup.get('password').hasError('required')">
                        {{'login.null-value-error'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-group col-md-6">
                    <mat-form-field  style="width: 90%;margin-left: 5px">
                      <input type="password" matInput placeholder="{{'sign-in.retype-password-placeholder'|translate}}"
                             formControlName="password_check" value = ""
                             [errorStateMatcher]="matcher" required>
                      <mat-error *ngIf="formGroup.get('password_check').hasError('minlength') && !formGroup.get('password').hasError('required')" >
                        {{'sign-in.password-rule-1'|translate}}
                      </mat-error>
                      <mat-error *ngIf="formGroup.get('password_check').hasError('required')">
                        {{'login.null-value-error'|translate}}
                      </mat-error>
                      <mat-error *ngIf="formGroup.get('password').value != formGroup.get('password_check').value">
                        {{'sign-in.passwords-error'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" style="margin-top: -20px">
                  <div class="form-group col-md-8">
                    <mat-form-field style="width: 90%;margin-left: 5px">
                      <input matInput placeholder="Inserisci l'indirizzo" formControlName="indirizzo"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('indirizzo').hasError('required')">
                        L'indirizzo è richiesto
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-group col-md-4">
                    <mat-form-field  style="width: 85%;margin-left: 5px">
                      <input matInput placeholder="Civico" formControlName="civico"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('civico').hasError('required')">
                        Il numero civico è richiesto
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" style="margin-top: -20px">
                  <div class="form-group col-md-6">
                    <mat-form-field  style="width: 90%;margin-left: 5px">
                      <input matInput placeholder="Inserisci la città" formControlName="citta"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('citta').hasError('required')">
                        La città è richiesta
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-group col-md-6">
                    <mat-form-field  style="width: 90%;margin-left: 5px">
                      <input matInput placeholder="Inserisci il CAP" formControlName="cap"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('cap').hasError('required')">
                        Il CAP è richiesto
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" style="margin-top: -20px">
                  <div class="form-group col-md-12">
                    <mat-form-field style="width: 95%;margin-left: 5px">
                      <input matInput placeholder="Inserisci il codice fiscale" formControlName="fisc_code"
                             [errorStateMatcher]="matcher" value="" required>
                      <mat-error *ngIf="formGroup.get('fisc_code').hasError('pattern') &&
         !formGroup.get('fisc_code').hasError('required')">
                        Codice Fiscale non valido
                      </mat-error>
                      <mat-error *ngIf="formGroup.get('fisc_code').hasError('required')">
                        Il Codice Fiscale è richiesto
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" *ngIf="!signedIn">
                  <p style="width: 80%; margin-left: 10%;font-size: 11px">Registrandoti dichiari di aver letto ed accettato i
                    <a href="../../../assets/privacy.pdf" target="_blank">termini e condizioni</a>
                  </p>
                </div>

                <div class="row" *ngIf="signedIn" style="margin-left: 10%; width: 80%" >
                  <p *ngIf="signInResponse.result">{{'sign-in.result-1'|translate}}</p>
                  <p *ngIf="!signInResponse.result">{{'sign-in.result-2'|translate}}</p>
                  <p *ngIf="!signInResponse.result">{{signInResponse.message}}</p>
                </div>
              </form>
              <div>
                <button (keyup.enter)="signInClick()" (click)="signInClick()" *ngIf="!signedIn"
                        style="width: 80%; margin-left: 10%; margin-top: -20px"
                        class="btn btn-primary btn-arrow" type="button" [disabled]="loading">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                  Richiedi Applicazione
                </button>
              </div>
            </div>


            <div class="col-lg-12">
              <div class="card m-t-40">
                <div class="row">
                  <div class="col-lg-4 col-md-4">
                    <div class="card-body d-flex no-block c-detail p-l-0">
                      <div class="m-r-20 align-self-center">
                        <img src="../../../assets/images/icon1.png">
                      </div>
                      <div class="">
                        <h6 class="font-medium">Address</h6>
                        <p class="">Conegliano, TV
                          <br> Italia</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <div class="card-body d-flex no-block c-detail">
                      <div class="m-r-20 align-self-center">
                        <img src="../../../assets/images/icon2.png">
                      </div>
                      <div class="">
                        <h6 class="font-medium">Phone</h6>
                        <p class="">327 054 5144</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <div class="card-body d-flex no-block c-detail">
                      <div class="m-r-20 align-self-center">
                        <img src="../../../assets/images/icon3.png">
                      </div>
                      <div class="">
                        <h6 class="font-medium">Email</h6>
                        <p class="">info@assetcopier.com</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Contact 3  -->
    <!-- ============================================================== -->

    <a class="bt-top btn btn-circle btn-lg btn-info" href="#top"><i class="ti-arrow-up"></i></a>
  </div>

</div>
